import { gql } from "@apollo/client";
import { useLazyQuery } from "@apollo/client/react";
import { useEffect, useState } from "react";
import styled from "styled-components";

import RevitBuiltInParameter from "./RevitBuiltInParameter";
import RevitBuiltInParameters from "./RevitBuiltInParameters.graphql";
import { FluidAccent } from "../../../../modules/ui-kit";

export const Component = styled(RevitBuiltInParameter)`
    ${ FluidAccent }
`;

export function getID(entity) {
    return entity.id;
}

export const name = "RevitBuiltInParameter";

export function useSearch(token: string) {
    const [execute, { called, data, error, loading }] = useLazyQuery(
        gql(RevitBuiltInParameters),
    );

    useEffect(
        () => {
            if (token.length < 3) return;

            if (!called) {
                void execute();
            }
        },
        [called, token],
    );

    const [results, setResults] = useState(undefined);

    useEffect(
        () => {
            if (token.length > 2 && data) {
                setResults(
                    data.revitBuiltInParameters.filter(
                        (parameter) => [
                            parameter.id.includes(token),
                            parameter.key.toLowerCase().includes(token.toLowerCase()),
                            parameter.name.some(
                                (tr) => tr.text.toLowerCase().includes(token.toLowerCase())
                            ),
                        ].some(Boolean)
                    )
                );
            } else {
                setResults([]);
            }
        },
        [data, token],
    );

    return {
        error,
        loading,
        results,
    };
}
